import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  usersData: [],
  userById: {},
};

const UsersSlice = createSlice({
  name: "UsersSlice",
  initialState,
  reducers: {
    setUsersData: (state, action) => {
      state.usersData = action.payload;
    },
    setUserById: (state, action) => {
      state.userById = action.payload;
    }
  },
});
export const { setUsersData, setUserById } = UsersSlice.actions;

export default UsersSlice.reducer;
